/* Component Dependencies */
var mapWhatsNearbyTemplate = require('templates/mapWhatsNearby.hbs');
var AriesComponent = require('libs/aries-component');
var googleApiWrapper = require('js-google-api-wrapper');
var MarkerGroup = require('./helper/MarkerGroup');
var MarkerFactory = require('./helper/MarkerFactory');
var Popup = require('libs/popup');
var $ = require('jquery');

AriesComponent.create({

  type: 'mapWhatsNearby',

  template: {
    'mapWhatsNearby': mapWhatsNearbyTemplate
  },

  bindEvents: function ($) {
    var _self = this;

    // Hide tile for Chinese locale
    if(!_self.$el.data('displayTile')) {
      _self.$el.closest('.mi-sub-section').addClass('mi-sub-section-blank');
      _self.$el.remove();
      return;
    }

    _self.hotelInfo = _self.$el.data('hotelInfo') || {};
    _self.nearByAttractions =
      _self.getNearByAttractions(_self.$el.data('nearByAttractions'));

    // Hide tile if mandatory information are not available
    if (!(_self.nearByAttractions.length &&
      _self.hotelInfo.hasOwnProperty('latitude') &&
      _self.hotelInfo.hasOwnProperty('latitude') )) {
      _self.$el.closest('.mi-sub-section').addClass('mi-sub-section-blank');
      _self.$el.remove();
      return;
    }

    _self.labels = {
      phoneLabel: _self.$el.data('phoneLabel'),
			closeLabel: _self.$el.data('closeLabel'),
      webSiteLabel: _self.$el.data('websiteLabel'),
      baseUrl: _self.$el.data('baseUrl')
    };

    _self.loadMapsApi();
  },

  /**
   * Filter attractions data that have all the mandatory information present
   * @param {Array} nearByAttractions - array of near by attractions address
   * @return {Array} attractions array with mandatory information
   */
  getNearByAttractions: function (nearByAttractions) {
    var _nearByAttractions = nearByAttractions || [];
    return _nearByAttractions.filter(function (attraction) {
      return ( attraction.featured &&
      attraction.name &&
      attraction.addressInfo &&
      attraction.addressInfo.addressLine1 &&
      attraction.addressInfo.city );
    });
  },

  /**
   * Load Google API and initialize Map if at least one valid attraction details is resolved
   * @return {void}
   */
  loadMapsApi: function () {
    var _self = this;
    googleApiWrapper
      .loadApi(_self.$el.data('googleMapApiUrl'))
      .then(function () {
        return _self.geocodeNearByAddress(_self.nearByAttractions);
      })
      .then(function (geocoderResults) {
        _self.nearByDetails = _self.getValidAttractionDetails(geocoderResults, _self.labels);
        if (_self.nearByDetails.length) {
          _self.initMap();
          _self.initNearByMarkers();
          _self.registerModal();
          _self.$modalSelector = _self.$el.find('.js-popup');
          _self.$modalSelector.on('mfpOpen', _self.onModalOpen.bind(_self));
          _self.$modalSelector.on('mfpClose', _self.onModalClose.bind(_self));
        }
        else {
          _self.$el.closest('.mi-sub-section').addClass('mi-sub-section-blank');
          _self.$el.remove();
          return;
        }
      });
  },

  /**
   * Geocode nearby addresses
   * @param {Array} nearByAttractions - array of near by attractions address
   * @returns {Promise} Promise object that is resolved with google.maps.GeocoderResult object or undefined
   */
  geocodeNearByAddress: function (nearByAttractions) {
    var _self = this, geocoder, geocodePromises;
    geocoder = new google.maps.Geocoder();
    geocodePromises = nearByAttractions
      .map(function (attraction) {
        return _self.getGeocodeRequest(attraction);
      })
      .map(function (geocodeRequest) {
        return new Promise(function (resolve, reject) {
          geocoder.geocode(geocodeRequest, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              resolve(results);
            } else {
              reject(status);
            }
          });
        });
      })
      .map(function (promise) {
        return promise.catch(function () {
          return undefined;
        });
      });
    return Promise.all(geocodePromises);
  },

  /**
   * Filter valid attraction addresses
   * @param {Array} geocoderResults - array of google.maps.GeocoderResult
   * @param {Object} labels - Object with label data
   * @return {Array} array of valid attractions details
   */
  getValidAttractionDetails: function (geocoderResults, labels) {
    var _self = this;
    return geocoderResults
      .map(function (geocodedAddress) {
        return geocodedAddress && geocodedAddress[0].geometry.location;
      })
      .map(function (location, index) {
        return location && _self.getAttractionDetails(location, _self.nearByAttractions[index]);
      })
      .map(function (atractionDetails) {
        return  atractionDetails && $.extend(atractionDetails, labels);
      })
      .filter(Boolean);
  },

  /**
   * Build near by attractions details object
   * @param {Object} location - the google.maps.LatLng coordinates of near by attraction
   * @param {Object} attraction - near by attraction response
   * @return {Object} formatted attraction details with location
   */
  getAttractionDetails: function (location, attraction) {
    var attractionDetails = {};
    attractionDetails.location = location;
    attractionDetails.name = attraction.name;
    attractionDetails.url = attraction.url;
    attractionDetails.image = attraction.imageFile;
    attractionDetails.description = attraction.description;
    if(attraction.addressInfo) {
      attractionDetails.address = attraction.addressInfo.addressLine1 +
      ", " + attraction.addressInfo.city;
    }
    if(attraction.contactInfo) {     
      attractionDetails.phone = attraction.contactInfo.phone;
    }  
    return attractionDetails;
  },

  /**
   * Geocode nearby addresses
   * @param {Object} attraction - near by attraction address
   * @returns {Object} geocoding request object google.maps.GeocoderRequest to be sent to the Geocoder
   */
  getGeocodeRequest: function (attraction) {
    var addressList = [],
      geocodeRequest = {}, componentRestrictions = {};
    addressList.push(attraction.name);
    if (attraction.addressInfo) {

      address = attraction.addressInfo;
      addressList.push(address.addressLine1);
      addressList.push(address.city);

      if (address.postalCode) {
        componentRestrictions.postalCode = address.postalCode;
      }

      if (address.countryCode) {
        componentRestrictions.country = address.countryCode;
      }
    }
    geocodeRequest.address = addressList.filter(Boolean).join(", ");
    geocodeRequest.componentRestrictions = componentRestrictions;
    return geocodeRequest;
  },

  /**
   * Initialize Map with Hotel marker
   * @return {void}
   */
  initMap: function () {
    var _self = this;

    _self.hotelLatLng = new google.maps.LatLng(_self.hotelInfo.latitude, _self.hotelInfo.longitude);
    _self.hotelMap = _self.createMap(_self.$el.find('.l-map-container')[0], _self.hotelLatLng);

    // add full screen control on map
    _self.hotelMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(_self.$el.find('.l-fullscreen-control')[0]);

    var hotelMarker = MarkerFactory.createHotelMarker( new google.maps.OverlayView(), _self.hotelLatLng);
    hotelMarker.setMap(_self.hotelMap);

    _self.$el.removeClass('is-hidden')
      .addClass('is-visible');
  },

  /**
   * Configure and create map with hotel latitude and longitude
   * @param {HTMLElement} mapContainerElm - Map container DOM element
   * @param {Object} hotelLatLng - the google.maps.LatLng coordinates of hotel property
   * @return {Object} google.maps.Map object
   */
  createMap: function (mapContainerElm, hotelLatLng) {
    return new google.maps.Map(mapContainerElm, {
      center: hotelLatLng,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      mapTypeControl: true,
      mapTypeControlOptions: {
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.SATELLITE
        ],
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.TOP_LEFT
      }
    });
  },

  /**
   * Recenter map when modal is opened
   * @return {void}
   */
  onModalOpen: function () {
    var _self = this;
    _self.$el.addClass('is-fullscreen');
    _self.$el.closest('.mfp-content').addClass('l-max-width-max').css('border-radius', 0);
    google.maps.event.trigger(_self.hotelMap, "resize");
  },

  /**
   * Recenter map when modal is closed
   * @return {void}
   */
  onModalClose: function () {
    var _self = this;
    _self.$el.removeClass('is-fullscreen');
    google.maps.event.trigger(_self.hotelMap, "resize");
  },

  /**
   * Register modal to show hotel map in full screen
   * @return {void}
   */
  registerModal: function () {
    var fullScreenPopup = new Popup({
      items: {
        src: '.modal-content',
        type: 'inline'
      },
      selector: '.tile-map-whats-nearby .js-popup',
      mainClass: 'mi-gallery mi-gallery-full',
      alternateCloseMarkup: true,
      fullScreen: true
    });
    fullScreenPopup.register();
  },

  /**
   * Initialize near by point of interest markers
   * @return {void}
   */
  initNearByMarkers: function () {
    var _self = this, eventIdleListener, boundChangeListener, $overlayPanel;
    $overlayPanel = _self.$el.find('.l-overlay-panel');
    _self.markerGroup = new MarkerGroup(_self.hotelMap, _self.nearByDetails, $overlayPanel, google);
    _self.markerBounds = _self.markerGroup.getMarkerBounds();
    _self.markerBounds.extend(_self.hotelLatLng);
    _self.hotelMap.fitBounds(_self.markerBounds);
    google.maps.event.trigger(_self.hotelMap, "resize");

    eventIdleListener = google.maps.event.addListener(_self.hotelMap, "idle",
      function _eventIdleListener() {
        var mapBounds = _self.hotelMap.getBounds();
        var markerLocations = _self.markerGroup.getLocations()
          .filter(function (location) {
            return !mapBounds.contains(location);
          });

        if (markerLocations.length) {
          var mapZoom = _self.hotelMap.getZoom();
          _self.hotelMap.setZoom(mapZoom - 1);
        } else {
          google.maps.event.removeListener(boundChangeListener);
          google.maps.event.removeListener(eventIdleListener);
          _self.hotelMap.setZoom(_self.hotelMap.getZoom() - 1);
        }

      });

    boundChangeListener = google.maps.event.addListener((_self.hotelMap), 'bounds_changed', function () {
      if (!_self.hotelMap.getCenter().equals(_self.hotelLatLng)) {
        _self.hotelMap.setCenter(_self.hotelLatLng);
      }
    });

    // close overlay when click any other part of the map
    google.maps.event.addListener(this.hotelMap, 'click', function () {
      _self.markerGroup.toggleActiveMarker();
    });
  }

});
